<template>
    <div :class="['content', data.bIpone ? 'padIpone' : '']">
        <div class="logo">
            <img src="~@/assets/images/antV2/scheme/logo.png" alt="" />
        </div>
        <div class="top-header">
            <img src="~@/assets/images/antV2/scheme/scheme_text.png" alt="" />
        </div>
        <div class="address">
            {{ data.reporInfo.address ? data.reporInfo.address : "" }}
        </div>
        <div class="level_nav">
            <div :class="[data.nNavindex == index ? item.atcName : item.className]" v-for="(item, index) in data.arrNav" :key="index" @click="getNav(index)">
                {{ item.name }}
            </div>
        </div>
        <div :class="['second_nav']" v-show="data.nNavindex == 0">
            <div :class="[data.secondIndex == index ? 'atc_nav_strip' : '']" v-for="(item, index) in data.arrErnav" :key="index" :style="{ width: 100 / data.arrErnav.length + '%' }" @click="getAtcStr(item.openIndex, index)">
                {{ item.title }}
            </div>
        </div>
        <div :class="['second_nav_strip']" v-show="data.nNavindex == 0">
            <!-- , data.arrClass[data.secondIndex].leftClass -->
            <div :class="['strip']" :style="{
                    width: 100 / data.arrErnav.length + '%',
                    left: (100 / data.arrErnav.length) * data.bottomIndex + '%',
                }"></div>
        </div>
        <!-- 冷暖系统 -->
        <div :class="[
                'opacit',
                data.nNavindex == 0 && data.secondIndex == 0 && data.bShow ? 'noopacit' : '',
            ]">
            <codsystem v-if="data.nNavindex == 0 && data.secondIndex == 0" :reporInfo.sync="data.reporInfo" @sumbitzi="sumbit" @getRoom="getRoomfu"></codsystem>
        </div>
        <!-- 水系统 -->
        <div :class="[
                'opacit',
                data.nNavindex == 0 && data.secondIndex == 1 && data.bShow ? 'noopacit' : '',
            ]">
            <water v-if="data.nNavindex == 0 && data.secondIndex == 1" :reporInfo.sync="data.reporInfo" :bShowWaterText.sync="data.bShowWaterText" @sumbitzi="sumbit"></water>
        </div>
        <!-- 新风系统 -->
        <div :class="[
                'opacit',
                data.nNavindex == 0 && data.secondIndex == 2 && data.bShow ? 'noopacit' : '',
            ]">
            <freshs :reporInfo.sync="data.reporInfo" :bShowFreshsText.sync="data.bShowFreshsText" @sumbitzi="sumbit" v-if="data.nNavindex == 0 && data.secondIndex == 2"></freshs>
        </div>
        <!-- Al-Link -->
        <div :class="[
                'opacit',
                data.nNavindex == 0 && data.secondIndex == 3 && data.bShow ? 'noopacit' : '',
            ]">
            <ailink :reporInfo.sync="data.reporInfo" :bShowText.sync="data.bShowText" @sumbitzi="sumbit" v-if="data.nNavindex == 0 && data.secondIndex == 3"></ailink>
        </div>
        <!-- 方案设计 -->
        <div :class="['opacit', data.nNavindex == 1 && data.bShow ? 'noopacit' : '']">
            <design :arrVrList.sync="data.arrVrList" :nCuiltips="data.reporInfo.compare_index" :reporInfo.sync="data.reporInfo" :objOffer.sync="data.objOffer" v-if="data.nNavindex == 1"></design>
        </div>
        <!-- 经典案例 -->
        <div :class="['opacit', data.nNavindex == 2 && data.bShow ? 'noopacit' : '']">
            <classic :arrRanks.sync="data.arrRanks" v-if="data.nNavindex == 2"></classic>
        </div>
        <!-- 末端设备选型 -->
        <div class="currency_suggest" v-if="data.nNavindex == 0 && data.secondIndex == 0">
            <div class="titel">
                <span>末端设备选型</span>
            </div>
            <div v-for="(item, index) in data.reporInfo.sub" :key="index" v-show="index < data.nRoomNumber">
                <div class="room_num">
                    <div class="title_xiao_room">
                        {{ item.room | roomNumber }}
                    </div>
                </div>
                <div class="tabe">
                    <div class="tabe_header">
                        <div :class="[
                                'header_nav',
                                index == 0 ? 'header_width_one' : '',
                                index == 1 ? 'header_width_two' : '',
                                index == 2 ? 'header_width_three' : '',
                                index == 3 ? 'header_width_four' : '',
                                index == 4 ? 'header_width_five' : '',
                            ]" v-for="(item, index) in data.arrDeviceNav" :key="index">
                            {{ item.titel }}
                        </div>
                    </div>
                    <div class="tabe_list">
                        <div class="warp" v-for="(sumitem, sumindex) in item.rooms" v-show="sumitem.product.length" :key="sumindex">
                            <div class="header_nav header_width_one">
                                {{ sumitem.name }}
                            </div>
                            <div class="header_nav header_width_two">
                                {{ Number(sumitem.area).toFixed(0) }}
                            </div>
                            <div class="header_width_three" ref="htmlHeight">
                                <div class="warp_conter" v-for="(
                                        sopitem, sopindex
                                    ) in sumitem.product" :key="sopindex">
                                    <div class="shopp_type">
                                        <div v-if="sopitem.mark">
                                            {{ sopitem.mark }}<br />
                                        </div>
                                        <div v-if="sopitem.product_id != 633">
                                            {{ sopitem.goods_name }}
                                        </div>
                                    </div>
                                    <div class="shopp_item">
                                        {{
                                            sopitem.attr_two.length
                                                ? sopitem.attr_two[0].attr_value
                                                : "/"
                                        }}
                                    </div>
                                    <div class="shopp_item">
                                        {{
                                            sopitem.attr_two.length == 2
                                                ? sopitem.attr_two[1].attr_value
                                                : "/"
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn_gd" @click="getGd" v-if="data.reporInfo.sub.length > 1 && data.nRoomNumber == 1">
                --&nbsp;点击查看更多&nbsp;--
            </div>
            <div class="btn_gd" @click="getSqgd" v-if="
                    data.reporInfo.sub.length > 1 &&
                    data.reporInfo.sub.length == data.nRoomNumber
                ">
                --&nbsp;点击收起更多&nbsp;--
            </div>
            <!-- 点击查看详细末端选型配置清单 -->
            <div class="btn" @click="getEnd">点击查看详细末端选型配置清单</div>
        </div>
        <div class="zh_btn">
            <div class="share_btn" v-if="data.objOffer.constructor != Array" @click="getReportupdate">打印版输出</div>
        </div>
        <div :class="['second_nav_bottom']" v-if="data.nNavindex == 0">
            <div :class="[data.bottomIndex == index ? 'atc_nav_strip_bottom' : '']" :style="{ width: 100 / data.arrErnav.length + '%' }" v-for="(item, index) in data.arrErnav" :key="index" @click="getAtcStrBottom(item.openIndex, index)">
                {{ item.title }}
            </div>
        </div>
        <!-- 末端选型 -->
        <end :bShowEnd.sync="data.bShowEnd" :reporInfo.sync="data.reporInfo"></end>
    </div>
</template>
<script>
import detail from "@/js/detail.js";
import end from "../editscheme/components/end/index"; //末端选项
import classic from "../editscheme/components/classic/index.vue"; //经典案例
import design from "../editscheme/components/design/index.vue"; //设计方案
import freshs from "../editscheme/components/freshs/index.vue"; //新风系统
import ailink from "../editscheme/components/ailink/index.vue"; //<!-- Al_Link -->
import water from "../editscheme/components/water/index.vue"; //<!-- 水系统 -->
import codsystem from "../editscheme/components/codsystem/index.vue"; //<!-- 冷暖系统 -->
import { getRoom } from "@/js/ant/basicinfov2.js";
import { getAttr, noRepeat } from "@/js/ant/scheme.js";
import { objData } from "./data/objdata.js";
export default {
    components: {
        design,
        classic,
        codsystem,
        water,
        freshs,
        ailink,
        end,
    },
    data() {
        return {
            data: objData(),
        };
    },
    filters: {
        roomNumber(index) {
            return getRoom(index)
        },
    },
    destroyed: function () {
        this.$storage.removeStorage("antMap");
    },
    created() {
        let that = this;
        if (this.$storage.getStorage("antMap") != false) {
            this.data.nNavindex = this.$storage.getStorage("antMap");
        } else {
            this.data.nNavindex = 0;
        }
        $init((res) => {
            that.$store.commit("loadSwitch", true);
            Promise.all([
                that.getReportinfo(),
                that.getCheck(),
            ]).then((res) => { });
        });
    },
    methods: {
        //报价单
        getCheck() {
            let that = this;
            detail
                .getCheck({ report_id: that.$route.query.reportId })
                .then((res) => {
                    let objOffer = res.result;
                    objOffer.arrInfo = [];
                    if (objOffer.constructor != Array && objOffer.info.length) {
                        objOffer.info.forEach((it, index) => {
                            if (it.goods.length != 0) {
                                objOffer.arrInfo.push(it);
                            }
                        });
                    }
                    that.data.objOffer = objOffer;
                });
        },
        getGd() {
            this.data.nRoomNumber = this.data.reporInfo.sub.length;
        },
        getSqgd() {
            this.data.nRoomNumber = 1;
        },
        //重新加载图片
        cXlogin() {
            this.data.bShowBtn = false;
            this.data.count = 0;
            this.data.nLoading = 0;
            this.getImages();
        },
        //推荐案例
        getRanks(city_id) {
            let that = this;
            detail.getRanks({ cityId: city_id }).then((res) => {
                let arrRanks = res.result;
                that.data.arrRanks = arrRanks;
            });
        },
        //点击导航获取子标签的索引值
        getRoomfu(e) {
            this.data.nRooms = e;
        },
        //提交获取子标签的值
        sumbit(e) {
            //子组件提交成功
            //category==0默认 category==1为水系统  category==2 为新风系统   category==3  为ailink系统
            if (!e.nMark && e.tag_id == 0) {
                this.data.reporInfo.tags[e.nIndex].type_desc = e.eaitDeas;
            } else if (!e.nMark && e.tag_id != 0 && e.category == 1) {
                this.data.reporInfo.tags[e.nIndex].strDeas = e.eaitDeas;
            } else if (!e.nMark && e.tag_id != 0 && e.category == 2) {
                this.data.reporInfo.tags[e.nIndex].strDeasFreshs = e.eaitDeas;
            } else if (!e.nMark && e.tag_id != 0 && e.category == 3) {
                this.data.reporInfo.tags[e.nIndex].strDeasAilink = e.eaitDeas;
            } else if (e.nMark && e.nType == 0) {
                this.data.reporInfo.mark = e.eaitDeas;
            } else if (e.nMark && e.nType == -1) {
                this.data.reporInfo.mark_extra = e.eaitDeas;
            }
        },
        //点击末端选项
        getEnd() {
            this.data.bShowEnd = true;
        },
        //拼接字符
        arrStr(arr, connectStr) {
            var str = "";
            let nStar = 0;
            //遍历数组
            arr.forEach((ele) => {
                nStar++;
                if (nStar == arr.length) {
                    str += ele;
                } else {
                    str += ele + String(connectStr);
                }
            });
            return str;
        },
        //案例编辑
        getReportupdate() {
            let _that = this;
            let reporInfo = _that.data.reporInfo;
            let attach = [];
            let rooms = [];
            let energy = [];
            let product = [];
            let desc = [];//配置说明设置数组不变，假如修改了数据，详情接口tag->type_desc  会返回修改字段
            let config_ids = [];
            reporInfo.goods_album.forEach(it => {
                if (it.setImg != '') {
                    attach.push({ type: it.type, img: it.setImg })
                }
            })
            reporInfo.tags.forEach(tag =>{
                tag.items.forEach(item => {
                    desc.push({type:tag.type,tag_id:tag.tag_id,desc:item.desc})
                    config_ids.push(item.id);
                })
            })
            reporInfo.sub.forEach(it => {
                let arrRooms = [];
                let arrEnergy = [];
                let arrProductGoods = [];
                it.arrGoods.forEach(ig => {
                    ig.itemsGoods.items.forEach(item => {
                        arrProductGoods.push({ product_id: item.product_id, num: item.num })
                    })
                })
                product.push({
                    room:it.room,
                    level:0,
                    energy_percent:it.energy_percent,
                    water_flow:it.water_flow,
                    water_temp:it.water_temperature,
                    water_cold:it.water_cold,
                    water_rate:it.water_rate,
                    water_clean:it.water_clean,
                    water_soft:it.water_soft,
                    wind_exchange:it.wind_exchange,
                    wind_area:it.wind_area,
                    temperature_design:it.temperature_design,
                    product:arrProductGoods,
                })
                it.rooms.forEach(item => {
                    let arrProduct = [];
                    item.product.forEach(ia => {
                        arrProduct.push({ product_id: ia.product_id, num: ia.num })
                    })
                    //房间负荷信息数组
                    arrEnergy.push({
                        product: arrProduct,
                        name: item.name,
                        room_id: item.room_id,
                        area: item.area,
                        temperature: item.temperature,
                        floor: item.floor,
                        extend_hot: item.extend_hot,
                        extend_cold: item.extend_cold,
                        direction: item.direction,
                        energy_hot: item.energy_hot,
                        energy_hot_per: item.energy_hot_per,
                        energy_cold: item.energy_cold,
                        energy_cold_per: item.energy_cold_per
                    })
                    arrRooms.push({ name: item.name, room_id: item.room_id, area: item.area, common_use: item.common_use })
                })
                energy.push({ room: it.room, energy: arrEnergy })
                rooms.push({ room: it.room, rooms: arrRooms })
            })
            let data = {
                report_id: _that.$route.query.reportId,//报告id
                wind_uid: reporInfo.wind_user_id || 0,//业主id，虚拟时为0
                uname: reporInfo.uname,//业主姓名
                uphone: reporInfo.phone,//业主电话号码
                latitude: reporInfo.latitude,//纬度
                longitude: reporInfo.longitude,//经度
                city_id: reporInfo.city_id,//城市id
                floor: reporInfo.floor,//层高
                warm_keep: reporInfo.warm_keep,//外墙保温 0无 1有
                warm_length: reporInfo.warm_length,//窗户隔热 1单 2双
                warm_percent: reporInfo.warm_percent,//窗墙比
                pipe_length: reporInfo.pipe_length,//管道长度
                address: reporInfo.address,//详细地址
                area: reporInfo.area,//面积
                compare_index: reporInfo.compare_index,//对比索引
                config_num: reporInfo.config_num,//家庭人数
                third_img: reporInfo.third_img || '',//第三方附件图片
                mark: reporInfo.mark,//说明文本
                markextra: reporInfo.mark_extra || '',//其他需求
                floorplan_id: reporInfo.floorplan_id,//酷家乐ID
                third_room_type: reporInfo.third_room_type || '',
                config_ids: config_ids.join(','),//标签id串，英文逗号拼接
                attach: JSON.stringify(attach),//图片附件信息数组
                rooms: JSON.stringify(rooms),//房间信息数组
                energy: JSON.stringify(energy),//房间负荷信息数组
                product: JSON.stringify(product),// 房间商品信息
                desc: JSON.stringify(desc),//配置说明设置数组
            };
            //  console.log(_that.data.reporInfo)
            //  console.log(data,product,desc)
            debugger
            _that.$store.commit('loadSwitch', true);
            detail.getReportupdate(data).then(res => {

            })
        },
        //获取方案书详情
        getReportinfo() {
            let that = this;
            let reportData = {
                // user_id:'192',
                report_id: that.$route.query.reportId,
                show_sub: 1, //子报告
                show_room: 1, //房间信息
                show_attach: 1, //附件信息
                show_product_type: 1, //产品类型
                show_product: 1, //方案商品
                show_tag: 1, //标签信息
                show_common: 1, //通用信息
                chunk_room_product: 1, //房间数量是否根据风盘拆分
                show_card: 1, //获取名片
                qr_code: 1, //转化二维码
            };
            that.$store.commit("loadSwitch", true);
            detail.getReportinfo(reportData).then((res) => {
                //  console.log("报告详情", res);
                let reporInfo = res.result;
                //根据城市推荐案例
                reporInfo.bShowCard = that.data.bShowCard;
                that.getRanks(reporInfo.city_id);
                reporInfo.arrDeaFreshs = [];
                reporInfo.arrSub = []; //冷暖系统楼层
                reporInfo.arrFreshsSub = []; //风盘楼层
                reporInfo.arrWaterSub = []; //水系统楼层
                reporInfo.arrAliinkSub = []; //alilink 楼层
                reporInfo.arrProduct = []; //轻奢系列套餐
                reporInfo.water_soft = 0; //总最大软水用量
                reporInfo.water_clean = 0; //总最大软水用量
                reporInfo.water_energy = 0; //热水需求负荷
                reporInfo.water_rate = 0; //热水设计流量
                //附件循环push到固定轮播图前面
                reporInfo.goods_album.forEach((item) => {
                    item.imgname = "";
                    item.setImg = "";
                    item.type = 0;
                });
                reporInfo.attach.forEach((item) => {
                    reporInfo.goods_album.unshift({
                        img: item.items[0].img_url,
                        setImg: item.items[0].img,
                        imgname: item.name,
                        type: item.type,
                    });
                });
                // 套餐报价
                reporInfo.product.forEach((res) => {
                    res.attr_one = []; // 右边重要卖点
                    res.attr_two = []; // 下面参数
                    res.attr_three = []; //末端选项参数
                    getAttr(res.attr, res.attr_one, res.attr_two, res.attr_three, res)
                    reporInfo.arrProduct.unshift(res);
                });
                //人员需求是否选择老人小孩女士
                let arrPersonnel = reporInfo.config_ids.split(",");
                let strPersonnel = "";
                arrPersonnel.forEach((it) => {
                    if (it == 55) {
                        if (strPersonnel == "") {
                            strPersonnel = "高龄老人";
                        } else {
                            strPersonnel = strPersonnel + "、高龄老人";
                        }
                    } else if (it == 56) {
                        if (strPersonnel == "") {
                            strPersonnel = "体弱女性";
                        } else {
                            strPersonnel = strPersonnel + "、体弱女性";
                        }
                    } else if (it == 57) {
                        if (strPersonnel == "") {
                            strPersonnel = "年幼儿童";
                        } else {
                            strPersonnel = strPersonnel + "、年幼儿童";
                        }
                    }
                });
                //系统定制需求
                let arrColstDeas = [];
                reporInfo.tags.forEach((tag) => {
                    tag.arrColstDeas = arrColstDeas;
                    tag.arrDeas = [];
                    tag.arrWater = []; //水系统里面的人员需求
                    tag.arrFreshs = []; //新风系统的人员需求
                    tag.arrAilink = []; //ailink的人员需求
                    tag.arrXiaji = []; //冬季需求
                    tag.arrHuasa = []; //水系统里面的花洒
                    tag.name = "";
                    tag.nameClass = "";
                    if (tag.type == 1) {
                        tag.name = "作息需求";
                        tag.nameClass = "two_icon";
                        tag.items.forEach((des) => {
                            if (des.desc != "" && des.tag_id != 31) {
                                tag.arrDeas.push("*" + des.desc);
                                tag.tag_id = 0;
                            }
                            if (des.desc != "" && des.tag_id == 31) {
                                reporInfo.warm_state_text = des.name;
                            }
                        });
                        //拼接文字
                        let strDeas = this.arrStr(tag.arrDeas, "<br/>");
                        tag.strDeas = strDeas;
                    }
                    if (tag.type == 2 || tag.type == 3) {
                        tag.name = "人员需求";
                        tag.nameClass = "one_icon";
                        tag.items.forEach((des) => {
                            if (
                                (des.desc == "" &&
                                    (des.tag_id == 31 ||
                                        des.id == 64 ||
                                        des.id == 82 ||
                                        des.id == 61,
                                        62,
                                        63)) ||
                                (des.id != 65 && des.tag_id == 38) ||
                                (des.id == 108 && des.tag_id == 33)
                            ) {
                            } else {
                                if (des.id == 84) {
                                    des.desc =
                                        des.desc + "，家中有" + strPersonnel;
                                }
                                arrColstDeas.push("*" + des.desc);
                                tag.tag_id = 0;
                            }
                        });
                        //拼接文字
                        this.$nextTick(() => {
                            let strDeas = this.arrStr(
                                tag.arrColstDeas,
                                "<br/>"
                            );
                            tag.strDeas =
                                strDeas +
                                "为了保证身体健康，冬季需要更温暖的室内环境";
                        });
                    }
                    if (tag.type == 5) {
                        tag.name = "冬季室温需求";
                        tag.nameClass = "three_icon";
                        tag.items.forEach((des) => {
                            if (des.desc != "" && des.tag_id != 31) {
                                tag.arrDeas.push("*" + des.desc);
                                tag.tag_id = 0;
                            }
                        });
                        //拼接文字
                        let strDeas = this.arrStr(tag.arrDeas, "<br/>");
                        tag.strDeas = strDeas;
                    }
                    if (tag.type == 4) {
                        tag.name = "夏季室温需求";
                        tag.nameClass = "four_icon";
                        tag.items.forEach((des) => {
                            if (des.desc != "" && des.id == 85) {
                                tag.arrDeas.push("*" + des.desc);
                                tag.tag_id = 0;
                            }
                        });
                        //拼接文字
                        let strDeas = this.arrStr(tag.arrDeas, "<br/>");
                        tag.strDeas = strDeas;
                    }
                    if (tag.type == 3) {
                        tag.name = "人员需求";
                        tag.nameClass = "one_icon";
                        //拼接文字
                        tag.items.forEach((des) => {
                            if (des.desc != "" && des.id == 64) {
                                tag.arrWater.push("*" + des.desc);
                                tag.tag_id = des.id;
                            }
                            if (des.desc != "" && des.id == "61,62,63") {
                                tag.arrFreshs.push("*" + des.desc);
                                tag.tag_freshs_id = des.id;
                            }
                            if (des.desc != "" && des.id == 65) {
                                tag.arrAilink.push("*" + des.desc);
                                tag.tag_ailink_id = des.id;
                            }
                            if (des.desc != "" && des.id == 83) {
                                tag.arrXiaji.push("*" + des.desc);
                            }
                            if (des.desc != "" && des.id == 108) {
                                tag.arrHuasa.push("*" + des.desc);
                                tag.tag_huasa_id = des.id;
                            }
                        });
                        // tag.strDeas = strDeas;
                        //拼接文字
                        let strHuasa = this.arrStr(tag.arrHuasa, "<br/>");
                        let strDeas = this.arrStr(tag.arrDeas, "<br/>");
                        let arrWater = this.arrStr(tag.arrWater, "<br/>");
                        let strDeasFreshs = this.arrStr(tag.arrFreshs, "<br/>");
                        let strDeasAilink = this.arrStr(tag.arrAilink, "<br/>");
                        if (strDeasAilink == "") {
                            this.data.bShowText = false;
                        }
                        if (strDeasFreshs == "") {
                            this.data.bShowFreshsText = false;
                        }
                        if (arrWater == "") {
                            this.data.bShowWaterText = false;
                        }
                        tag.strHuasa = strHuasa;
                        tag.arrWater = arrWater;
                        tag.strDeas = strDeas;
                        tag.strDeasFreshs = strDeasFreshs;
                        tag.strDeasAilink = strDeasAilink;
                    }
                });
                let numToilet = 0; //卫生间数量
                let numKitchen = 0; //厨房数量
                let numWindKou = 0; //风口数量
                let numHqcs = 0; //换气次数
                let arrNumHqcs = []; //换气数组
                let numFreshs = 0; //新风风量
                let numWindArea = 0; //换气面积
                let arrDeaFreshs = []; //新风系统
                let arrDeaAilink = []; //Allink
                let arrDeaWater = []; //水系统
                let arrDeaCod = []; //冷暖系统
                reporInfo.sub.forEach((it) => {
                    it.arrWater = []; //水系统
                    it.arrCodsystem = []; //冷暖系统
                    it.arrFreshs = []; //新风系统
                    it.arrAilink = []; //Ailink
                    it.arrProther = []; //除Ailink外所有系统报价商品
                    it.arrGoods = [];
                    if (it.product.length) {
                        it.product.forEach((aet) => {
                            if (aet.level == 0) {
                                aet.items.forEach((item) => {
                                    let itemsGoods = {};
                                    let arrItems = [];
                                    item.items.forEach((sys) => {
                                        arrItems = [...arrItems, ...sys.items]
                                        itemsGoods = {
                                            items: arrItems,
                                            new_goods_type_id: sys.new_goods_type_id,
                                            new_goods_type_name: sys.new_goods_type_name
                                        }
                                        sys.items.forEach((ad) => {
                                            ad.attr_three = []; //末端选项参数
                                            ad.attr.forEach((ib) => {
                                                ib.attr_name =
                                                    ib.attr_name.replace(
                                                        /[\ +\r\n]/g,
                                                        ""
                                                    );
                                                if (ib.attr_mean > 3) {
                                                    ad.attr_three.push(ib);
                                                }
                                            });
                                        });
                                    });
                                    it.arrGoods.push({
                                        system_id: item.system_id,
                                        system_name: item.system_name,
                                        itemsGoods: itemsGoods,
                                    })
                                    if (item.system_id == 1) {
                                        item.items.forEach((sys) => {
                                            sys.items.forEach((ad) => {
                                                if (
                                                    ad.new_goods_type_id ==
                                                    215 ||
                                                    ad.new_goods_type_id == 216
                                                ) {
                                                } else {
                                                    it.arrCodsystem.push(ad);
                                                }
                                            });
                                            if (sys.items.length > 0) {
                                                //  console.log(it);
                                                reporInfo.arrSub.push(it);
                                            }
                                        });
                                        //判断是否为冷暖系统，然后数组去重
                                        reporInfo.arrSub = noRepeat(
                                            reporInfo.arrSub, "room"
                                        );
                                    }
                                    if (item.system_id == 3) {
                                        item.items.forEach((sys) => {
                                            sys.items.forEach((ad) => {
                                                it.arrFreshs.push(ad);
                                            });
                                            if (sys.items.length > 0) {
                                                reporInfo.arrFreshsSub.push(it);
                                            }
                                        });
                                        //判断是否为风盘系统，然后数组去重
                                        reporInfo.arrFreshsSub = noRepeat(
                                            reporInfo.arrFreshsSub, "room"
                                        );
                                    }
                                    if (
                                        item.system_id == 4 ||
                                        item.system_id == 2
                                    ) {
                                        item.items.forEach((sys) => {
                                            sys.items.forEach((ad) => {
                                                it.arrWater.push(ad);
                                            });
                                            if (sys.items.length > 0) {
                                                reporInfo.arrWaterSub.push(it);
                                            }
                                        });
                                        //判断是否为水系统，然后数组去重
                                        reporInfo.arrWaterSub = noRepeat(
                                            reporInfo.arrWaterSub, "room"
                                        );
                                    }
                                    if (item.system_id == 5) {
                                        item.items.forEach((sys) => {
                                            sys.items.forEach((ad) => {
                                                it.arrAilink.push(ad);
                                            });
                                            if (sys.items.length > 0) {
                                                reporInfo.arrAliinkSub.push(it);
                                            }
                                        });
                                        //判断是否为Alink系统，然后数组去重
                                        reporInfo.arrAliinkSub = noRepeat(
                                            reporInfo.arrAliinkSub, "room"
                                        );
                                        //  console.log(reporInfo.arrAliinkSub);
                                    } else {
                                        item.items.forEach((sys) => {
                                            sys.items.forEach((ad) => {
                                                it.arrProther.push(ad);
                                            });
                                        });
                                    }
                                });
                                it.arrFreshs.forEach((ie) => {
                                    arrDeaFreshs.push(ie);
                                });
                                it.arrAilink.forEach((ie) => {
                                    arrDeaAilink.push(ie);
                                });
                                it.arrWater.forEach((ie) => {
                                    arrDeaWater.push(ie);
                                });
                                it.arrCodsystem.forEach((ie) => {
                                    arrDeaCod.push(ie);
                                });
                                arrDeaWater = noRepeat(arrDeaWater, "shopp");
                            }
                        });
                        //用文字匹配需要用的重要参数
                        // 冷暖系统
                        it.arrCodsystem.forEach((ia) => {
                            ia.attr_one = []; // 右边重要卖点
                            ia.attr_two = []; // 需要展示的重要参数
                            ia.attr_three = [];
                            getAttr(ia.attr, ia.attr_one, ia.attr_two, ia.attr_three, ia)
                        });
                        //水系统
                        it.arrWater.forEach((ia) => {
                            ia.attr_one = []; // 右边重要卖点
                            ia.attr_two = []; // 需要展示的重要参数
                            ia.attr_three = [];
                            getAttr(ia.attr, ia.attr_one, ia.attr_two, ia.attr_three, ia)
                        });
                        //循环房间
                        it.rooms.forEach((room, index) => {
                            room.openId = index;
                            room.open = true;
                            room.product.forEach((sh) => {
                                sh.attr_one = []; // 右边重要卖点
                                sh.attr_two = []; // 下面参数
                                sh.attr_three = []; //末端选项参数
                                getAttr(sh.attr, sh.attr_one, sh.attr_two, sh.attr_three, sh)
                                reporInfo.numWindKou = numWindKou += Number(
                                    sh.num
                                );
                            });
                        });
                    }
                    //计算厨房卫生间
                    reporInfo.numFreshs = numFreshs += Number(it.wind_energy);
                    reporInfo.numHqcs = numHqcs += Number(it.wind_exchange); //换气次数
                    arrNumHqcs.push(it.wind_exchange);
                    reporInfo.numChishu = Math.max(...arrNumHqcs);
                    reporInfo.numToilet = numToilet += it.num_toilet;
                    reporInfo.numKitchen = numKitchen += it.num_kitchen;
                    reporInfo.numWindArea = numWindArea += Number(it.wind_area);
                    reporInfo.water_soft = reporInfo.water_soft += Number(
                        it.water_soft
                    ); //总最大软水用量
                    reporInfo.water_clean = reporInfo.water_clean += Number(
                        it.water_clean
                    ); //总最大软水用量
                    reporInfo.water_energy = reporInfo.water_energy += Number(
                        it.water_energy
                    ); //热水需求负荷
                    reporInfo.water_rate = reporInfo.water_rate += Number(
                        it.water_rate
                    ); //热水设计流量
                });
                //系统报价
                let arrSysterm = [
                    { title: "Step1冷暖风水系统设备", sub: reporInfo.sub },
                    { title: "Step2末端设备", sub: reporInfo.sub },
                    { title: "Step3控制系统", sub: reporInfo.sub },
                ];
                arrDeaFreshs.forEach((it) => {
                    // 新风系统
                    it.attr_one = []; // 右边重要卖点
                    it.attr_two = []; // 需要展示的重要参数
                    it.attr_three = [];
                    getAttr(it.attr, it.attr_one, it.attr_two, it.attr_three, it)
                });
                arrDeaAilink.forEach((it) => {
                    // Ai_link
                    it.attr_one = []; // 右边重要卖点
                    it.attr_two = []; // 需要展示的重要参数
                    it.attr_three = [];
                    getAttr(it.attr, it.attr_one, it.attr_two, it.attr_three, it)
                });
                reporInfo.arrSysterm = arrSysterm;
                reporInfo.arrDeaAilink = arrDeaAilink;
                reporInfo.arrDeaFreshs = arrDeaFreshs;
                reporInfo.arrDeaWater = arrDeaWater;
                reporInfo.arrDeaCod = arrDeaCod;
                reporInfo.arrSwiperImg = that.data.arrSwiperImg;
                //  console.log(arrDeaFreshs.length == 0);
                if (arrDeaAilink.length == 0) {
                    that.data.arrErnav.splice(3, 1);
                }
                if (arrDeaFreshs.length == 0) {
                    that.data.arrErnav.splice(2, 1);
                }
                if (arrDeaWater.length == 0) {
                    that.data.arrErnav.splice(1, 1);
                }
                if (arrDeaCod.length == 0) {
                    that.data.arrErnav.splice(0, 1);
                }
                that.data.reporInfo = reporInfo;
                that.$store.commit("loadSwitch", false);
            });
        },
        getBright(index) {
            this.data.bShowVideo = false;
            this.data.nBright = index;
        },
        //点击一级导航
        getNav(index) {
            this.data.bShow = true;
            this.$storage.setStorage("antMap", index);
            this.data.nNavindex = index;
        },
        getAtcStrBottom(index, boIndex) {
            this.getScrollTop(0, 200);
            this.data.secondIndex = index;
            this.data.bottomIndex = boIndex;
        },
        //点击二级导航
        getAtcStr(index, boIndex) {
            this.data.bShow = true;
            this.data.bottomIndex = boIndex;
            this.data.secondIndex = index;
        },
        //滚动条滚动
        getScrollTop(number = 0, time) {
            let that = this;
            if (!time) {
                document.body.scrollTop = document.documentElement.scrollTop =
                    number;
                return number;
            }
            const spacingTime = 20; // 设置循环的间隔时间  值越小消耗性能越高
            let spacingInex = time / spacingTime; // 计算循环的次数
            let nowTop =
                document.body.scrollTop + document.documentElement.scrollTop; // 获取当前滚动条位置
            let everTop = (number - nowTop) / spacingInex; // 计算每次滑动的距离
            let scrollTimer = setInterval(() => {
                if (spacingInex > 0) {
                    spacingInex--;
                    that.getScrollTop((nowTop += everTop));
                } else {
                    clearInterval(scrollTimer); // 清除计时器
                }
            }, spacingTime);
        },
    },
};
</script>
<style lang="scss" scoped>
.zh_btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.share_btn {
    width: 300px;
    height: 80px;
    border-radius: 40px;
    border: solid 2px #023f88;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #023f88;
    margin: 48px auto 0;
}
@import "index.scss";
</style>
